import { AsyncPipe, CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';

import { RouterModule } from '@angular/router';
import { AgrPageModule, AgrPrimaryActionModule } from '@next/core-lib/components';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ProfileComponent } from './profile.component';
import { SharedModule } from '../shared/shared.module';
import { BasicInformationComponent } from './basic-information/basic-information.component';
import { LicensesComponent } from './licenses/licenses.component';
import { ProfileEffects } from './store/effects/profile.effects';

import { profileReducer } from './store/reducers/profile.reducer';

@NgModule({
  declarations: [
    // add shared components here
    ProfileComponent,
    BasicInformationComponent,
    LicensesComponent,
  ],
  imports: [
    // add shared modules here
    CommonModule,
    AsyncPipe,
    SharedModule,
    MatSortModule,
    MatCardModule,
    MatFormFieldModule,
    MatTableModule,
    AgrPageModule,
    AgrFormModule,
    MatAutocompleteModule,
    MatIconModule,
    AgrPrimaryActionModule,
    MatTabsModule,
    MatInputModule,
    MatButtonModule,
    MatExpansionModule,
    MatSelectModule,
    MatTreeModule,
    MatSlideToggleModule,
    RouterModule,
  ],
  providers: [provideState('profileModule', profileReducer), provideEffects([ProfileEffects])],
})
export class ProfileModule {}
